import {
  AdminHeader,
  AdminSpinner,
  SearchInput,
  Tab,
  TabsWrapper,
  handleSetUrlSearchParams,
  useDebouncedValue,
  useUIState,
  useVerificationsCount,
} from '@vgrubs/components';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AgentsSection } from './sections/Agents';
import { RestaurantsSection } from './sections/Restaurants';
import { VDriveVerifications } from './sections/VDriveVerifications';
import { BrandsVerifications } from './sections/BrandsVerifications';

/**
 * One search box for all four tabs: it filters whichever tab is open, and
 * lives in the URL so a reload or a link keeps it.
 */
export const Verifications = () => {
  const { verificationsTab, setVerificationsTab } = useUIState(
    (state) => state
  );

  const [searchParams, setSearchParams] = useSearchParams();
  const [search, setSearch] = useState(searchParams.get('query') || '');
  const query = useDebouncedValue(search.trim(), 300);

  const onSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
    handleSetUrlSearchParams('query', event.target.value, setSearchParams);
  };

  const { count, isLoading } = useVerificationsCount();

  return (
    <>
      {isLoading && <AdminSpinner />}

      <AdminHeader
        title={`Verifications (${
          count.locations + count.agents + count.vDrive + count.brands
        })`}
      >
        <SearchInput
          value={search}
          maxWidth="350px"
          maxWidthSM="125px"
          placeholder="Search"
          onChange={onSearchChange}
        />
      </AdminHeader>

      <TabsWrapper>
        <Tab
          selected={verificationsTab === 1}
          onClick={() => setVerificationsTab(1)}
        >
          Restaurants ({count.locations})
        </Tab>
        <Tab
          selected={verificationsTab === 2}
          onClick={() => setVerificationsTab(2)}
        >
          Agents ({count.agents})
        </Tab>
        <Tab
          selected={verificationsTab === 3}
          onClick={() => setVerificationsTab(3)}
        >
          vDrive ({count.vDrive})
        </Tab>
        <Tab
          selected={verificationsTab === 4}
          onClick={() => setVerificationsTab(4)}
        >
          Brands ({count.brands})
        </Tab>
      </TabsWrapper>

      {verificationsTab === 1 && <RestaurantsSection query={query} />}
      {verificationsTab === 2 && <AgentsSection query={query} />}
      {verificationsTab === 3 && <VDriveVerifications query={query} />}
      {verificationsTab === 4 && <BrandsVerifications query={query} />}
    </>
  );
};
